// import "../../css/Forms.css";
// import React, { useState } from "react";
// import { Form, Input, Select, Checkbox, Button } from "antd";
// import { countriesList } from "../../utils/countriesList";
// import { sectorsList } from "../../utils/sectorsList";
// import { inputs, buttons } from "langs/contactForm";
// import {
//   populateGclid,
//   populateUtmSource,
//   populateUtmMedium,
//   populateUtmCampaign,
//   populateUtmTerm,
//   populateUtmContent,
// } from "../../utils/utmHelpers";

// const { Option } = Select;

// const PartnerForm = ({ lang }) => {
//   const [form] = Form.useForm();
//   const [messageLength, setMessageLength] = useState(0);

//   const handleFinish = async (values) => {
//     const requestOptions = {
//       method: "POST",
//       mode: "no-cors",
//     };

//     const params = decodeURIComponent(new URLSearchParams(values).toString());
//     const url = `https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&oid=00D7R000005HP0B&${params}`;

//     await fetch(url, requestOptions)
//       .then((response) => console.log("Formulario enviado con éxito:", response))
//       .catch((error) => console.log("Error:", error));

//     form.resetFields();
//   };

//   const handleTextAreaChange = (e) => {
//     setMessageLength(e.target.value.length);
//   };

//   return (
//     <section className="partner-form-container">
//       <Form
//         form={form}
//         layout="vertical"
//         onFinish={handleFinish}
//         initialValues={{ remember: false }}
//         className="form-partner"
//       >
//         {/* Campos ocultos */}
//         <Form.Item name="oid" initialValue="00D7R000005HP0B" style={{ display: "none" }}>
//           <Input type="hidden" />
//         </Form.Item>
//         <Form.Item name="retURL" initialValue={`/${lang}/thankyou`} style={{ display: "none" }}>
//           <Input type="hidden" />
//         </Form.Item>
//         <Form.Item name="lead_source" initialValue="MKT-Partner Web Forms" style={{ display: "none" }}>
//           <Input type="hidden" />
//         </Form.Item>
//         <Form.Item name="00N7R00000H84xV" initialValue={populateUtmCampaign()} style={{ display: "none" }}>
//           <Input type="hidden" />
//         </Form.Item>
//         <Form.Item name="00N7R00000H84xW" initialValue={populateUtmContent()} style={{ display: "none" }}>
//           <Input type="hidden" />
//         </Form.Item>
//         <Form.Item name="00N7R00000H84xX" initialValue={populateUtmMedium()} style={{ display: "none" }}>
//           <Input type="hidden" />
//         </Form.Item>
//         <Form.Item name="00N7R00000H84xY" initialValue={populateUtmSource()} style={{ display: "none" }}>
//           <Input type="hidden" />
//         </Form.Item>
//         <Form.Item name="00N7R00000H84xZ" initialValue={populateUtmTerm()} style={{ display: "none" }}>
//           <Input type="hidden" />
//         </Form.Item>
//         <Form.Item name="00N7R00000H84xL" initialValue="English" style={{ display: "none" }}>
//           <Input type="hidden" />
//         </Form.Item>

//         {/* Campos visibles */}
//         <div className="two-fields-partner">
//           <Form.Item
//             label={inputs[lang].fieldName.label}
//             name="first_name"
//             rules={[{ required: true, message: inputs[lang].fieldName.emptyRule }]}
//           >
//             <Input placeholder="Juan" />
//           </Form.Item>
//           <Form.Item
//             label={inputs[lang].fieldLastname.label}
//             name="last_name"
//             rules={[{ required: true, message: inputs[lang].fieldLastname.emptyRule }]}
//           >
//             <Input placeholder="Moreira" />
//           </Form.Item>
//         </div>

//         <div className="two-fields-partner">
//           <Form.Item
//             label={inputs[lang].fieldEmail.label}
//             name="email"
//             rules={[
//               { required: true, message: inputs[lang].fieldEmail.emptyRule },
//               { type: "email", message: inputs[lang].fieldEmail.validRule },
//             ]}
//           >
//             <Input placeholder="Corporate email" />
//           </Form.Item>
//           <Form.Item
//             label={inputs[lang].fieldCompany.label} // Campo agregado para "Company"
//             name="company"
//             rules={[{ required: true, message: inputs[lang].fieldCompany.emptyRule }]}
//           >
//             <Input placeholder="Company name" />
//           </Form.Item>
//         </div>

//         <div className="two-fields-partner">
//           <Form.Item
//             label={inputs[lang].fieldWebCorporative.label} // Campo agregado para "URL"
//             name="url"
//             rules={[{ required: true, message: inputs[lang].fieldWebCorporative.emptyRule }]}
//           >
//             <Input placeholder="www.companyurl.com" />
//           </Form.Item>
//           <Form.Item
//             label={inputs[lang].fieldIndustry.label}
//             name="industry"
//             rules={[{ required: true, message: inputs[lang].fieldIndustry.emptyRule }]}
//           >
//             <Select placeholder="--Choose an option--" options={sectorsList} />
//           </Form.Item>
//         </div>

//         <div className="two-fields-partner">
//           <Form.Item
//             label={inputs[lang].fieldCountry.label}
//             name="country_code"
//             rules={[{ required: true, message: inputs[lang].fieldCountry.emptyRule }]}
//           >
//             <Select placeholder="--Choose an option--" options={countriesList} />
//           </Form.Item>
//         </div>

//         <div className="Forms-textarea-full">
//           <Form.Item
//             label={inputs[lang].fieldComments.label}
//             name="00N7R00000H84xH"
//           >
//             <Input.TextArea maxLength={400} onChange={handleTextAreaChange} />
//             <div style={{ textAlign: "right" }}>{messageLength}/400</div>
//           </Form.Item>
//         </div>

//         <Form.Item
//           name="heleido"
//           valuePropName="checked"
//           rules={[
//             {
//               validator: (_, value) =>
//                 value ? Promise.resolve() : Promise.reject(new Error(inputs[lang].fieldPrivacy.emptyRule)),
//             },
//           ]}
//         >
//           <Checkbox>
//             <a href={`/${lang}/politicas-de-privacidad`} target="_blank">
//               {inputs[lang].fieldPrivacy.label}
//             </a>
//           </Checkbox>
//         </Form.Item>

//         <Form.Item>
//           <Button htmlType="submit" className="button-yellow-md">
//             {buttons[lang].contact}
//           </Button>
//         </Form.Item>
//       </Form>
//     </section>
//   );
// };

// export default PartnerForm;

const PartnerForm = () => {
    // const handleSubmit = (e) => {
    //     e.preventDefault(); // Evita el comportamiento predeterminado del formulario
    //     const form = e.target;
    
    //     // Envía el formulario a Salesforce
    //     fetch(form.action, {
    //       method: form.method,
    //       body: new FormData(form),
    //     })
    //       .then(() => {
    //         // Redirige al home después del envío exitoso
    //         window.location.href = "/";
    //       })
    //       .catch((error) => {
    //         console.error("Error al enviar el formulario:", error);
    //       });
    // };
      
    return (
        
      <>
        <section className="partner-form-container">
            <form
                className="form-partner"
                action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&orgId=00D7R000005HP0B"
                method="POST"
                //onSubmit={handleSubmit} // Escucha el evento submit
            >
            {/* Campos ocultos */}
            <input type="hidden" name="oid" value="00D7R000005HP0B" />
            <input type="hidden" name="retURL" value="/es/thankyou" />
            <input type="hidden" id="lead_source" name="lead_source" value="MKT-Partner Web Forms" />
            <input type="hidden" id="00N7R00000H84xV" name="00N7R00000H84xV" value="TBD" />
            <input type="hidden" id="00N7R00000H84xW" name="00N7R00000H84xW" value="TBD" />
            <input type="hidden" id="00N7R00000H84xX" name="00N7R00000H84xX" value="TBD" />
            <input type="hidden" id="00N7R00000H84xY" name="00N7R00000H84xY" value="TBD" />
            <input type="hidden" id="00N7R00000H84xZ" name="00N7R00000H84xZ" value="TBD" />
            <input type="hidden" id="00N7R00000H84xL" name="00N7R00000H84xL" value="English" />
  
            {/* Campos visibles */}
            <div className="two-fields-partner">
              <div className="field-partnership">
                <label htmlFor="first_name" title="Name">Name*</label>
                <input
                  placeholder="Juan"
                  id="first_name"
                  className="ant-input css-dev-only-do-not-override-7ny38l ant-input-outlined"
                  type="text"
                  name="first_name"
                />
              </div>
              <div className="field-partnership">
                <label htmlFor="last_name" title="Last Name">Last name*</label>
                <input
                  placeholder="Moreira"
                  id="last_name"
                  className="ant-input css-dev-only-do-not-override-7ny38l ant-input-outlined"
                  type="text"
                  name="last_name"
                />
              </div>
            </div>
  
            <div className="two-fields-partner">
              <div className="field-partnership">
                <label htmlFor="email" title="Email">Corporate email*</label>
                <input
                  placeholder="Corporate email"
                  id="email"
                  className="ant-input css-dev-only-do-not-override-7ny38l ant-input-outlined"
                  type="email"
                  name="email"
                />
              </div>
              <div className="field-partnership">
                <label htmlFor="company" title="Company">Company name</label>
                <input
                  placeholder="Company name"
                  id="company"
                  className="ant-input css-dev-only-do-not-override-7ny38l ant-input-outlined"
                  type="text"
                  name="company"
                />
              </div>
            </div>
  
            <div className="two-fields-partner">
              <div className="field-partnership">
                <label htmlFor="url" title="Website">Website*</label>
                <input
                  placeholder="www.companyurl.com"
                  id="url"
                  className="ant-input css-dev-only-do-not-override-7ny38l ant-input-outlined"
                  type="text"
                  name="url"
                />
              </div>
            </div>
  
            <div className="two-fields-partner">
              <div className="field-partnership">
                <label htmlFor="industry" title="Industry">Industry*</label>
                <select
                    defaultValue=""
                    id="industry"
                    className="ant-input css-dev-only-do-not-override-7ny38l ant-input-outlined"
                    name="industry"
                >
                  {/* <option value="" disabled selected>--Choose an option--</option> */}
                  <option value="Consultancy Services">Consultancy Services</option>
                  <option value="e-Commerce">E-Commerce</option>
                  <option value="Education">Education</option>
                  <option value="e-Learning">E-Learning</option>
                  <option value="Financial Services">Financial Services</option>
                  <option value="Financial Technology">Financial Technology</option>
                  <option value="Gambling">Gambling</option>
                  <option value="Multilevel Marketing">Multilevel Marketing</option>
                  <option value="Saas">Saas</option>
                  <option value="Sports Betting">Sports Betting</option>
                  <option value="Technology provider">Technology provider</option>
                  <option value="Ticketing">Ticketing</option>
                  <option value="Tourism">Tourism</option>
                  <option value="Travel">Travel</option>
                  <option value="Others">Others</option>
                </select>
              </div>
              <div className="field-partnership">
                <label htmlFor="country_code" title="Country">Country*</label>
                <select
                    defaultValue=""
                    id="country_code"
                    className="ant-input css-dev-only-do-not-override-7ny38l ant-input-outlined"
                    name="country_code"
                >
                  {/* <option value="" disabled selected>--Choose an option--</option> */}
                  <option value="US">United States</option>
                  <option value="ES">Spain</option>
                  <option value="FR">France</option>
                  <option value="DE">Germany</option>
                  <option value="IT">Italy</option>
                  <option value="BR">Brazil</option>
                  <option value="MX">Mexico</option>
                  <option value="AR">Argentina</option>
                  <option value="CO">Colombia</option>
                  <option value="CL">Chile</option>
                  <option value="PE">Peru</option>
                  <option value="VE">Venezuela</option>
                  <option value="UY">Uruguay</option>
                  <option value="PY">Paraguay</option>
                  <option value="BO">Bolivia</option>
                </select>
              </div>
            </div>
  
            <div className="two-fields-partner">
              <div className="field-partnership">
                <label htmlFor="00N7R00000H84xH" title="Comments">Let us know how we can help.</label>
                <textarea
                  id="00N7R00000H84xH"
                  name="00N7R00000H84xH"
                  className="ant-input css-dev-only-do-not-override-7ny38l text-partnership-form ant-input-outlined"
                  wrap="soft"
                ></textarea>
              </div>
            </div>
  
            <div className="check-box-partner-form ant-row ant-form-item-row css-dev-only-do-not-override-7ny38l">
              <div className="ant-col ant-form-item-control css-dev-only-do-not-override-7ny38l">
                <div className="ant-form-item-control-input">
                  <div className="ant-form-item-control-input-content">
                    <label className="ant-checkbox-wrapper ant-checkbox-wrapper-in-form-item css-dev-only-do-not-override-7ny38l">
                      <span className="ant-checkbox ant-wave-target css-dev-only-do-not-override-7ny38l">
                        <input id="heleido" className="ant-checkbox-input" type="checkbox" />
                        <span className="ant-checkbox-inner"></span>
                      </span>
                      <span>
                        <a href="/es/politicas-de-privacidad" target="_blank">Accept privacy policy *</a>
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
  
            <button
              type="submit"
              className="ant-btn css-dev-only-do-not-override-7ny38l ant-btn-default ant-btn-color-default ant-btn-variant-outlined btn-partnership-form button-yellow-md"
            >
              <span>Contact our team</span>
            </button>
          </form>
        </section>
      </>
    );
  };
  
  export default PartnerForm;

